import { Box, PieChart, PieChartEntry } from '@auviknetworks/iceberg-ui';
import { Typography } from '@mui/material';
import { popoverContentsColumns } from 'application/Shared/Components/Recharts/PopoverContents';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const CategoryOverview = (props: {
    renderingScheduledReport: boolean;
    categoryData: PieChartEntry[];
}) => {
    const { t } = useTranslation();
    const { renderingScheduledReport, categoryData } = props;

    return (
        <Box sx={{ marginBottom: '64px' }}>
            <Typography variant="h3" sx={{ marginBottom: '24px' }}>
                {t('Reports.ApplicationOverlapReport.categoryOverview.title')}
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: '16px' }}>
                {t(
                    'Reports.applicationOverlapReport.categoryOverview.description'
                )}
            </Typography>

            <PieChart
                data={categoryData}
                emptyMessage={t('Common.noData')}
                isAnimationActive={!renderingScheduledReport}
                popoverContentsColumns={popoverContentsColumns}
                responsiveContainerHeight={250}
            />
        </Box>
    );
};
